<!-- Card Container -->
<div class="card">
  <!-- Card Header -->
  <div class="px-4 py-3 border-b border-gray-200 dark:border-gray-700">
    <h3 class="text-lg font-semibold text-gray-800 dark:text-gray-100">
      Select a Report
    </h3>
  </div>

  <!-- Card Body -->
  <div class="p-4">
    <kendo-dropdownlist
      [data]="reportTypes"
      [defaultItem]="defaultDropdownItem"
      textField="text"
      valueField="value"
      valuePrimitive="true"
      class="w-64"
      (valueChange)="reportTypeChange($event)"
      [(ngModel)]="selectedReportType"
    >
    </kendo-dropdownlist>
  </div>
</div>

<!-- Second Card -->
<div
  *ngIf="selectedReportTypeSettings"
  class="mt-4 bg-white border border-gray-200 rounded-lg shadow-lg dark:bg-gray-800 dark:border-gray-700"
>
  <!-- Card Header -->
  <div class="px-4 py-3 border-b border-gray-200 dark:border-gray-700">
    <h3 class="text-lg font-semibold text-gray-800 dark:text-gray-100">
      {{ selectedReportTypeSettings?.reportTitle }}
    </h3>
  </div>

  <!-- Card Body -->
  <div class="p-4">
    <form
      [formGroup]="reportForm"
      (ngSubmit)="onFormSubmit($event)"
      class="space-y-4"
    >
      <!-- Account Forms Radio Buttons -->
      <div *ngIf="selectedReportTypeSettings?.accountFormsRadioButtons">
        <div class="space-y-2 text-sm">
          <label class="flex items-center space-x-2">
            <input
              type="radio"
              value="0"
              formControlName="selectedReport"
              kendoRadioButton
            />
            <span>Account forms with a status of missing</span>
          </label>
          <label class="flex items-center space-x-2">
            <input
              type="radio"
              value="1"
              formControlName="selectedReport"
              kendoRadioButton
            />
            <span>Account forms that are at least 3 years old</span>
          </label>
          <label class="flex items-center space-x-2">
            <input
              type="radio"
              value="2"
              formControlName="selectedReport"
              kendoRadioButton
            />
            <span
              >Account forms that are within 3 months of being 3 years old (33
              months)</span
            >
          </label>
        </div>
      </div>

      <!-- Search By Radio Buttons -->
      <div *ngIf="selectedReportTypeSettings?.searchByRadioButtons">
        <div class="mb-2 text-sm font-semibold">Search By:</div>
        <label class="flex items-center space-x-2">
          <input
            type="radio"
            kendoRadioButton
            formControlName="searchBySelection"
            (click)="
              searchSelectionChange(searchBySelectionEnum.SearchByBranch)
            "
            [value]="searchBySelectionEnum.SearchByBranch"
          />
          <span>Branch</span>
        </label>
       <!--  <label class="flex items-center space-x-2">
          <input
            type="radio"
            kendoRadioButton
            formControlName="searchBySelection"
            (click)="searchSelectionChange(searchBySelectionEnum.SearchByRep)"
            [value]="searchBySelectionEnum.SearchByRep"
          />
          <span>Rep</span>
        </label> -->
         <label class="flex items-center space-x-2">
          <input
            type="radio"
            kendoRadioButton
            formControlName="searchBySelection"
            (click)="searchSelectionChange(searchBySelectionEnum.SearchByAll)"
            [value]="searchBySelectionEnum.SearchByAll"
          />
          <span>All Reps</span>
        </label>
        <hr class="my-2" />

        <!-- Branch Multiselect -->
        <div
          *ngIf="
            reportForm.value.searchBySelection ===
            searchBySelectionEnum.SearchByBranch
          "
          id="chosse"
        >
          <span class="block mb-1">Choose a Branch:</span>
          <kendo-multiselect
            style="width: 260px"
            [data]="crdBranches"
            textField="crdBranchName"
            valueField="crdBranchNumber"
            formControlName="selectedCrdBranches"
            [autoClose]="false"
            [popupSettings]="{ width: 300 }"
            [clearButton]="false"
            [valuePrimitive]="true"
            (close)="
              multiSelectValueChange(searchBySelectionEnum.SearchByBranch)
            "
          >
          </kendo-multiselect>
        </div>

        <!-- Rep Multiselect -->
        <div
          *ngIf="
            reportForm.value.searchBySelection ===
            searchBySelectionEnum.SearchByRep
          "
          class="mt-2"
        >
          <kendo-label [for]="multiselect" text="Choose a Rep:"></kendo-label>
          <kendo-multiselect
            #multiselect
            [data]="repList"
            textField="fullName"
            valueField="repId"
            formControlName="selectedReps"
            [autoClose]="false"
            [popupSettings]="{ height: 300 }"
            [clearButton]="false"
            [valuePrimitive]="false"
            (close)="multiSelectValueChange(searchBySelectionEnum.SearchByRep)"
          >
            <ng-template kendoMultiSelectTagTemplate let-dataItem>
              {{ dataItem.fullName }}
            </ng-template>
          </kendo-multiselect>
        </div>
        <hr class="my-2" />
      </div>

      <!-- Account Transaction Radio Buttons -->
      <div *ngIf="selectedReportTypeSettings?.accountTransactionRadioButtons">
        <div class="mb-2 text-sm font-semibold">Report Type:</div>
        <label class="flex items-center space-x-2">
          <input
            type="radio"
            kendoRadioButton
            formControlName="searchReportType"
            (click)="hideTransactionControls()"
            [value]="searchReportTypeEnum.AccountReport"
          />
          <span>Account Report</span>
        </label>
        <label class="flex items-center space-x-2">
          <input
            type="radio"
            kendoRadioButton
            formControlName="searchReportType"
            (click)="showTransactionControls()"
            [value]="searchReportTypeEnum.TransactionReport"
          />
          <span>Transaction Report</span>
        </label>
        <hr class="my-2" />
      </div>

      <!-- Date Pickers -->
      <div
        *ngIf="selectedReportTypeSettings?.showDates"
        class="flex items-center space-x-4"
      >
        <kendo-datepicker
          activeView="year"
          placeholder="Start Date"
          style="height: 32px; width: 250px"
          [size]="selectedSize"
          formControlName="startDate"
          [(ngModel)]="ngModelDate"
          [fillMode]="selectedFillMode"
        ></kendo-datepicker>
        <kendo-datepicker
          activeView="year"
          placeholder="End Date"
          style="height: 32px; width: 250px"
          [size]="selectedSize"
          formControlName="endDate"
          [(ngModel)]="ngModelendDate"
          [fillMode]="selectedFillMode"
        ></kendo-datepicker>
        @if (showTransactionFilterSelection) {
        <label class="flex items-center space-x-2">
          <input
            type="radio"
            kendoRadioButton
            [(ngModel)]="selectedTransactionFilter"
            [ngModelOptions]="{ standalone: true }"
            [value]="'All'"
          />
          <span>All</span>
        </label>
        <label class="flex items-center space-x-2">
          <input
            type="radio"
            kendoRadioButton
            [(ngModel)]="selectedTransactionFilter"
            [ngModelOptions]="{ standalone: true }"
            [value]="'Trading'"
          />
          <span>Trading</span>
        </label>
        <label class="flex items-center space-x-2">
          <input
            type="radio"
            kendoRadioButton
            [(ngModel)]="selectedTransactionFilter"
            [ngModelOptions]="{ standalone: true }"
            [value]="'AnnuitiesLife'"
          />
          <span>Annuities/Life</span>
        </label>
        }
      </div>
      <hr class="my-2" />

      <!-- Checkbox -->
      <div *ngIf="selectedReportTypeSettings?.excludeTransactionsCheckbox">
        <label class="flex items-center space-x-2">
          <input type="checkbox" kendoCheckBox />
          <span>Exclude Non-Purchase Transactions</span>
        </label>
      </div>

      <!-- Excel or PDF Option -->
      <div
        *ngIf="selectedReportTypeSettings?.excelPdfRadioButtons"
        class="space-y-1"
      >
        <label class="flex items-center space-x-2">
          <input
            type="radio"
            kendoRadioButton
            formControlName="searchReportFileType"
            [value]="searchReportFileTypeEnum.Excel"
          />
          <span>Excel</span>
        </label>
        <label class="flex items-center space-x-2">
          <input
            type="radio"
            kendoRadioButton
            formControlName="searchReportFileType"
            [value]="searchReportFileTypeEnum.Pdf"
          />
          <span>PDF</span>
        </label>
      </div>

      <!-- Submit Buttons -->
      <div class="pt-2">
        <button
          *ngIf="!formbutton"
          kendoButton
          look="outline"
          primary="true"
          type="submit"
          [disabled]="!reportForm.valid"
          class="px-4 py-2 text-blue-600 border border-blue-500 rounded-md hover:bg-blue-50"
        >
          Create Report
        </button>
        <button
          *ngIf="formbutton"
          kendoButton
          look="outline"
          primary="true"
          (click)="ExportToExcelDeleted(excelexportDeleted)"
          [disabled]="!reportForm.valid"
          class="px-4 py-2 text-blue-600 border border-blue-500 rounded-md hover:bg-blue-50"
        >
          Create Report
        </button>
      </div>
    </form>
  </div>
</div>

<!-- Excel Export -->
<kendo-excelexport
  [data]="gridExcelexportDeleted"
  [collapsible]="true"
  fileName="DeletedBlotterRecordsExport.xlsx"
  #excelexportDeleted
>
  <!-- Export Columns -->
  <kendo-excelexport-column
    field="blotterId"
    title="Transaction Id"
  ></kendo-excelexport-column>
  <kendo-excelexport-column
    field="clientId"
    title="Client Id"
    [width]="200"
  ></kendo-excelexport-column>
  <kendo-excelexport-column
    field="productTypeDesc2"
    title="Product Type"
    [width]="200"
  ></kendo-excelexport-column>
  <kendo-excelexport-column
    field="transactionTypeDesc"
    title="Transaction Type"
    [width]="50"
  ></kendo-excelexport-column>
  <kendo-excelexport-column
    field="accountNumber"
    title="Account Number"
    [width]="350"
  ></kendo-excelexport-column>
  <kendo-excelexport-column
    field="deletedBy"
    title="Deleted By"
    [width]="50"
  ></kendo-excelexport-column>
  <kendo-excelexport-column
    field="deletedDate"
    title="Deleted Date"
    [width]="50"
  ></kendo-excelexport-column>
  <kendo-excelexport-column
    field="productName"
    title="Product Name"
    [width]="50"
  ></kendo-excelexport-column>
  <kendo-excelexport-column
    field="amount"
    title="Amount"
    [width]="50"
  ></kendo-excelexport-column>
  <kendo-excelexport-column
    field="dateReceived"
    title="Date Received"
    [width]="50"
  ></kendo-excelexport-column>
  <kendo-excelexport-column
    field="approvedBy"
    title="Approved By"
    [width]="50"
  ></kendo-excelexport-column>
  <kendo-excelexport-column
    field="approvedByDate"
    title="Approved Date"
    [width]="50"
  ></kendo-excelexport-column>
  <kendo-excelexport-column
    field="dateSubmitted"
    title="Date Submitted"
    [width]="50"
  ></kendo-excelexport-column>
  <kendo-excelexport-column
    field="trackingNumber"
    title="Tracking Number"
    [width]="50"
  ></kendo-excelexport-column>
  <kendo-excelexport-column
    field="dateSigned"
    title="Date Signed"
    [width]="50"
  ></kendo-excelexport-column>
  <kendo-excelexport-column
    field="newAccountForm"
    title="New Account Form"
    [width]="50"
  ></kendo-excelexport-column>
  <kendo-excelexport-column
    field="dateOfNewAccountForm"
    title="Date of New Account Form"
    [width]="50"
  ></kendo-excelexport-column>
  <kendo-excelexport-column
    field="statusTypeDesc"
    title="StatusType Desc"
    [width]="50"
  ></kendo-excelexport-column>
  <kendo-excelexport-column
    field="blotterReviewId"
    title="Blotter Review ID"
    [width]="50"
  ></kendo-excelexport-column>
  <kendo-excelexport-column
    field="repFirstName"
    title="Rep First Name"
    [width]="50"
  ></kendo-excelexport-column>
  <kendo-excelexport-column
    field="repMiddleName"
    title="Rep Middle Name"
    [width]="50"
  ></kendo-excelexport-column>
  <kendo-excelexport-column
    field="repLastName"
    title="Rep Last Name"
    [width]="50"
  ></kendo-excelexport-column>
  <kendo-excelexport-column
    field="accountName"
    title="Account Name"
    [width]="50"
  ></kendo-excelexport-column>
  <kendo-excelexport-column
    field="mutualFundClassBdisclosureForm"
    title="Mutual Fund Class B Disclosure Form"
    [width]="50"
  ></kendo-excelexport-column>
  <kendo-excelexport-column
    field="clientFirstName"
    title="Client First Name"
    [width]="50"
  ></kendo-excelexport-column>
  <kendo-excelexport-column
    field="clientMiddleName"
    title="Client Middle Name"
    [width]="50"
  ></kendo-excelexport-column>
  <kendo-excelexport-column
    field="clientLastName"
    title="Client Last Name"
    [width]="50"
  ></kendo-excelexport-column>
</kendo-excelexport>

<!-- Excel Export - Non-Rep Entered Transactions (selection 5) -->
<kendo-excelexport
  [data]="gridExcelexportDeleted"
  [collapsible]="true"
  fileName="NonRepTransactionReport.xlsx"
  #excelexportNonRep
>
  <kendo-excelexport-column field="BlotterId" title="BlotterID"></kendo-excelexport-column>
  <kendo-excelexport-column field="FirstName" title="FirstName" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="LastName" title="LastName" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="MiddleName" title="MiddleName" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="AccountName" title="AccountName" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="Address1" title="Address1" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="Address2" title="Address2" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="City" title="City" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="State" title="State" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="ZipCode" title="ZipCode" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="TaxId" title="TaxID" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="RepId" title="RepID" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="RepName" title="RepName" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="RepCode" title="RepCode" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="ProductTypeDesc" title="ProductTypeDesc" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="AccountNumber" title="AccountNumber" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="SponsorName" title="SponsorName" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="TransactionTypeDesc" title="TransactionTypeDesc" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="StatusTypeDesc" title="StatusTypeDesc" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="ProductName" title="ProductName" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="Amount" title="Amount" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="DateReceived" title="DateReceived" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="ApprovedBy" title="ApprovedBy" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="ApprovedByDate" title="ApprovedByDate" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="DateSubmitted" title="DateSubmitted" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="TrackingNumber" title="TrackingNumber" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="DateSigned" title="DateSigned" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="NewAccountForm" title="NewAccountForm" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="DateOfNewAccountForm" title="DateOfNewAccountForm" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="CopyOfDl" title="CopyOfDL" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="SourceOfFundsTypeDesc" title="SourceOfFundsTypeDesc" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="CurrentStatement" title="CurrentStatement" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="DateSent" title="DateSent" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="DeliveryMethod" title="DeliveryMethod" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="CheckNumber" title="CheckNumber" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="CheckRemitter" title="CheckRemitter" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="MailDate" title="MailDate" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="DocumentDescription" title="DocumentDescription" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="ModifiedBy" title="ModifiedBy" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="InvestmentHorizon" title="InvestmentHorizon" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="InvestmentObjectiveDesc" title="InvestmentObjectiveDesc" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="LastComment" title="LastComment" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="EnteredByRep" title="EnteredByRep" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="SplitRepId" title="SplitRepID" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="SplitRepName" title="SplitRepName" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="CrdbranchName" title="CRDBranchName" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="ClientId" title="ClientID" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="ClientTypeDesc" title="ClientTypeDesc" [width]="50"></kendo-excelexport-column>
  <kendo-excelexport-column field="MutualFundClass" title="MutualFundClass" [width]="50"></kendo-excelexport-column>
</kendo-excelexport>
